import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

const getData = async () => {
	try {
		const data = await fetchJson('/rest/api/latest/serverInfo');
		return data.displayUrlCSMHelpSeeker?.replace(/^https?:\/\//, '');
	} catch (error) {
		fireErrorAnalytics({
			meta: {
				id: 'csmBaseUrlResource',
				packageName: 'jiraRouterResourcesServiceDeskCustomerServiceCsmBaseUrl',
				teamName: 'boysenberry',
			},
			error: error instanceof Error ? error : undefined,
		});

		throw error;
	}
};

export default getData;
